import { commonStyles } from "../stylesByClasses/common"
import { useSelector } from 'react-redux';
import ProductList from "../components/ProductList";
import { Underline } from "../components/Underline";

export const Shop = () => {

  const products = useSelector((state) => state.products);

  return (
    <div className="flex flex-col items-start justify-start pt-[20px] pb-[40px] h-auto">
      
      <div className="text-3xl font-bold flex flex-row gap-[40px] items-center justify-center mr-auto">
        Pickles
      </div>

      <Underline />

      <div className="w-full">
        <ProductList limit="150" products={products.pickles} />
      </div>

      <div className="text-3xl font-bold mt-[60px] flex flex-row gap-[40px] items-center justify-center mr-auto">
        Powders
      </div>

      <Underline />

      <div className="w-full">
        <ProductList limit="150" products={products.powders} />
      </div>

      <div className="text-3xl font-bold mt-[60px] flex flex-row gap-[40px] items-center justify-center mr-auto">
        Sweets
      </div>

      <Underline />

      <div className="w-full">
        <ProductList limit="15" products={products.sweets} />
      </div>

      <div className="w-full h-[60px]"></div>
    </div>
  )
}